<template>
  <a-modal v-model="visible" :maskClosable="false"  title="公式" :width="1200" @ok="handleOk" @cancel="onClose" @close="onClose">
    <a-row :gutter="48">
      <a-col :md="6" :sm="6" style="padding: 0 0 0 24px">
        <span>名称：</span>
        <a-input style="width:160px" placeholder="输入名字" v-model="countName" type="text" />
        <div style="border: solid 1px #eee;border-radius: 8px;height:700px;margin-top:10px;padding: 12px 6px;">
          <i aria-label="图标: search" tabindex="-1" class="anticon anticon-wechat item-icon active">
            <svg viewBox="64 64 896 896" data-icon="search" width="1em" height="1em" fill="currentColor"
              aria-hidden="true" focusable="false" class="">
              <path
                d="M674.8 196.2C538.6 60.1 315.2 64 184 208.1 65.4 338.3 68.5 543.6 190.7 670.4 312.7 797 508.1 807.6 642.8 703l211.8 211.6c16.6 16.5 43.4 16.5 59.9 0 16.6-16.5 16.6-43.3 0-59.9L702.7 643.1c103.5-132.8 94.4-324.8-27.9-446.9z m-31.9 386.1c-102.6 143-313 143-415.6 0-62.1-86.6-62.1-206.6 0-293.2 102.6-143 313-143 415.6 0 62.1 86.6 62.1 206.5 0 293.2z"
                fill="#333333" p-id="4268"></path>
            </svg>
          </i>
          <a-input style="width:180px" v-model="ziduan" placeholder="表内字段" type="text" />
          <div style="height: 100%;overflow-y: auto;">
            <a-tree v-if="detailTree.length > 0"
              class="draggable-tree"
              :tree-data="detailTree"
              defaultExpandAll
              :selectable="false"
              @select="treeSelect"
            >
              <template #title="{ title,key }">
                <span v-if="title.indexOf(ziduan) > -1" @click="treeSelect(title,key)">
                  {{ title.substr(0, title.indexOf(ziduan)) }}
                  <span style="color: #f50">{{ ziduan }}</span>
                  {{ title.substr(title.indexOf(ziduan) + ziduan.length) }}
                </span>
                <span v-else>{{ title }}</span>
              </template>
            </a-tree>
          </div>
        </div>
      </a-col>
      <a-col :md="18" :sm="18" style="padding: 0 0 0 24px">
        <a-row :gutter="48">
          <a-col :md="8" :sm="8" style="padding:0 0 0 24px">
            <span>单位：</span>
            <a-input style="width:180px" v-model="danwei" placeholder="单位" type="text" />
          </a-col>
          <a-col :md="10" :sm="10" style="padding:0 0 0 24px">
            <span>小数位数：</span>
            <a-input style="width:180px" v-model="xiaoshu" placeholder="小数位数" type="text" />
          </a-col>
          <a-col :md="6" :sm="6" style="padding:0 0 0 24px">
            <!-- <span>小数位数：</span> -->
            <div @click.stop="isQianwei = !isQianwei"><a-radio style="margin-top:6px" :checked="isQianwei">千位分割</a-radio>
            </div>
          </a-col>
        </a-row>
        <div style="border: solid 1px #eee;border-radius: 8px;height:400px;margin-top:10px;padding: 12px 6px;">
          <div class="section-title" style="display:flex;font-size: 16px;color:#333;font-weight: 1000;">
            <div class="title" style="">运算配置：</div>
            <div class="operation-btns" style="display:flex">
              <a-tooltip v-for="(item, index) in operations" :key="index" placement="top" style="padding:0 6px">
                <template slot="title">
                  <span>{{ item.descZDY }}</span>
                </template>
                <div class="btn" style="cursor: pointer;" @click="insertText(` ${item.title} `, 'operation')">{{
                  item.title }}</div>
              </a-tooltip>
            </div>
          </div>
          <FormulaEditor v-if="id != ''" ref="formulaEditorRef" v-model="formulaText" :functionOptions="functionOptions"
            :functionKeys="functionKeys" @checkedFunction="checkedFunction" @clear="clearErrorMessage" />
        </div>
        <a-row :gutter="48" style="margin-top: 12px">
          <a-col :md="8" :sm="8" style="padding:0 0 0 24px">
            <a-tabs class="" @change="tabsChange">
              <a-tab-pane v-for="item in functionOptions" :key="item.key" :tab="item.shortTitle"></a-tab-pane>
            </a-tabs>
            <div class="search-wrapper">
              <a-input v-model="searchFunction" icon="search" placeholder="搜索" :maxLength="30" @input="changeInput">
                <a-icon slot="prefix" type="search"></a-icon>
              </a-input>
            </div>
            <div style="height:240px;overflow:auto;margin-top:4px">
              <div v-for="(item, key0) in functionOptionsTab" style="cursor:pointer" :key="key0"
                @mousemove="handleMouseMove(item)" @click="insertText(`${item.key}`, item.type)">
                <div style="padding:4px"
                  :class="currentShowFunction && currentShowFunction.key == item.key ? 'optionActive' : ''">
                  {{ item.title }}</div>
              </div>
              <a-empty v-if="functionOptionsTab.length == []" :description="`未查询到:${searchFunction}`"></a-empty>
            </div>
          </a-col>
          <a-col :md="16" :sm="10">
            <div v-if="isShow">
              <div class="htmlDes" v-html="functionDescription"></div>
            </div>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
  </a-modal>
</template>

<script>
import { getGoodProperty,getGoodsPropertyLeaf,goodGongshiAdd,editGoodsFormula } from '@/api/goods/goods'
import { fieldFindRegExp, fieldReplaceRegExp, operations } from '@/utils/formula/setting'
import { convertNewFormulaToTest } from '@/utils/formula/utils'
import { convertOldFormulaText, convertNewFormulaToShow, convertNewFormulaToPost } from '@/utils/formula/utils'
import { Interpreter } from 'eval5'
import formulaFunctions from '@/utils/formula'
import { isBoolean, isEmpty, isJSONString, isObject } from '@/utils/formula/is'
// import { FormulaEditor, checkSearchResult, getEditorComponentsOptions } from '@/utils/formula/asyncUitls.ts'
import { functionOptions } from '@/utils/formula/options'
import FormulaEditor from '@/components/FormulaEditor'
// import error from '@/utils/formula/error'
const functionKeys = functionOptions
  .map((item) => [...item.lists.map((item) => item.key)])
  .reduce((prev, next) => {
    return prev.concat(next)
  }, [])
export default {
  name: 'CountStyle',
  components: {
    FormulaEditor
  },
  props: {
    // id: {
    //   type: [Number, String],
    //   default: '388688686394617856'
    // }
  },
  data() {
    return {
      countName: '',
      visible: false,
      ziduan: '',
      danwei: '',
      xiaoshu: '',
      isQianwei: false,
      formulaText: '',
      operations: operations,
      functionKeys: functionKeys,
      functionOptions: functionOptions,
      searchFunction: '',
      currentShowFunction: null,
      functionOptionsTab: functionOptions[0]['lists'],
      functionDescription: '',
      isShow: true,
      keyTab: functionOptions[0].key,
      isSuccess: false,
      detailTree: [],
      detailTrees: [],
      treeKeys: '',
      converdFields: [],
      errorText: '',
      updateList: null,
      id: ''
    }
  },
  created() {
    this.functionDescription = `
      <h3 style='margin-bottom: 6px'>提示</h3>
      <p style='margin-bottom: 6px;font-weight: 600;'>1. 手动输入符号须使用英文输入法；</p>
      <p style='margin-bottom: 6px;font-weight: 600;'>2. 手动输入文本时，使用英文双引号标识 (如 "输入的文字" )</p>
      <p style='margin-bottom: 6px;font-weight: 600;'>3. 不能存在并行函数 (如 函数(1) 函数(1) )</p>
      <p style='margin-bottom: 6px;font-weight: 600;'>4. 函数中不能存在多余的逗号， (如 函数(1,) )</p>
      <p style='margin-bottom: 6px;font-weight: 600;'>5. 手动键入+-*/等运算符时尽量在运算符前后增加空格</p>
      <p style='margin-bottom: 6px;font-weight: 600;'>6. 负数参与减法运算时必须给运算符-号前后增加空格，否则可能无法正确计算</p>
      <p style='margin-bottom: 6px;font-weight: 600;'>7. var 可以自定义变量</p>
    `
  },
  mounted(){
    console.info(FormulaEditor,"FormulaEditor++++++++++++++")
    // this.getDetail()
  },
  computed: {

  },
  methods: {
    // treeSelect(e,node){
    //   // console.error(node.selectedNodes)
    //   // console.error(node.selectedNodes[0].componentOptions.children.length)
    //   // console.error(node.selectedNodes[0].data.key)
    //   // console.error(node.selectedNodes[0].data.props.title)
    //   // this.insertText(` ${item.title} `, 'operation')
    //   if(node.selectedNodes.length){
    //     if(node.selectedNodes[0].componentOptions.children.length > 0){

    //     } else {
    //       this.insertText(`{{${node.selectedNodes[0].data.props.title}}}`, 'field')
    //     }
    //   }
    // },
    treeSelect(title,key){
      this.insertText(`{${title}}`, 'field')
    },
    getDetail () {
      console.info(FormulaEditor,"FormulaEditor++++++++++++++")
      this.loading = true
      getGoodProperty({
        goodsId: this.id
      }).then(response => {
        this.detailTree = JSON.parse(JSON.stringify(response.data))
        this.detailTrees = JSON.parse(JSON.stringify(response.data))
        console.info(this.detailTree)
        this.loading = false
      })
    },
    getPro(){
      getGoodsPropertyLeaf({
        goodsId: this.id
      }).then(response => {
        let arr = []
        for(var i = 0;i < response.data.length;i++){
          arr.push({
            fieldName: response.data[i].title,
            field: i,
            fieldId: response.data[i].key
          })
        }
        this.converdFields = arr
        console.info(this.converdFields)
        this.loading = false
      })
    },
    changeInput() {
      let arr = []
      if (!this.searchFunction) {
        arr = this.functionOptions
      } else {
        arr = this.functionOptions.map((item) => ({
          ...item,
          lists: item.lists.filter(
            (func) => `${func.key}${func.title}`.indexOf(this.searchFunction.toUpperCase()) != -1
          )
        })).filter((item) => !!item.lists.length)
      }
      if (arr.length == 0) {
        this.functionOptionsTab = []
        this.currentShowFunction = null
        return
      }
      for (var i = 0; i < arr.length; i++) {
        if (arr[i].key == this.keyTab) {
          this.functionOptionsTab = arr[i].lists
          this.currentShowFunction = null
          this.functionDescriptionFunc()
          break
        }
      }
    },
    functionDescriptionFunc() {
      if (this.currentShowFunction) {
        this.functionDescription = `<h3 style='margin-bottom: 6px'>${this.currentShowFunction.key}</h3>
          <p style='margin-bottom: 6px;font-weight: 600;'>函数描述：${this.currentShowFunction.desc}</p>
          <p style='margin-bottom: 6px;font-weight: 600;'>用法：${this.currentShowFunction.usage}</p>
          <p style='margin-bottom: 6px;font-weight: 600;'>示例：${this.currentShowFunction.example}</p>
        `
      } else {
        this.functionDescription = `<h3 style='margin-bottom: 6px'>提示</h3>
          <p style='margin-bottom: 6px;font-weight: 600;'>1. 手动输入符号须使用英文输入法；</p>
          <p style='margin-bottom: 6px;font-weight: 600;'>2. 手动输入文本时，使用英文双引号标识 (如 "输入的文字" )</p>
          <p style='margin-bottom: 6px;font-weight: 600;'>3. 不能存在并行函数 (如 函数(1) 函数(1) )</p>
          <p style='margin-bottom: 6px;font-weight: 600;'>4. 函数中不能存在多余的逗号， (如 函数(1,) )</p>
          <p style='margin-bottom: 6px;font-weight: 600;'>5. 手动键入+-*/等运算符时尽量在运算符前后增加空格</p>
          <p style='margin-bottom: 6px;font-weight: 600;'>6. 负数参与减法运算时必须给运算符-号前后增加空格，否则可能无法正确计算</p>
          <p style='margin-bottom: 6px;font-weight: 600;'>7. var 可以自定义变量</p>
        `
      }
    },
    handleMouseMove(item) {
      if (this.currentShowFunction && item.key == this.currentShowFunction.key) {
        return
      }
      this.currentShowFunction = item
      this.functionDescriptionFunc()
    },
    tabsChange(e) {
      this.keyTab = e
      let arr = []
      if (!this.searchFunction) {
        arr = this.functionOptions
      } else {
        arr = this.functionOptions.map((item) => ({
          ...item,
          lists: item.lists.filter(
            (func) => `${func.key}${func.title}`.indexOf(this.searchFunction.toUpperCase()) != -1
          )
        })).filter((item) => !!item.lists.length)
      }
      if (arr.length == 0) {
        this.functionOptionsTab = []
        this.currentShowFunction = null
        return
      }
      for (var i = 0; i < arr.length; i++) {
        if (arr[i].key == this.keyTab) {
          this.functionOptionsTab = arr[i].lists
          this.currentShowFunction = null
          this.functionDescriptionFunc()
          break
        }
      }
    },
    open(id) {
      if(!id){
        this.$message.error('请输入商品id')
      } else {
        this.id = id
        this.getDetail()
        this.getPro()
        this.visible = true
      }
    },
    updated(list) {
      this.updateList = list
      console.info(list,'更新')
      this.id = list.goodsId
      this.getDetail()
      this.getPro()
      this.visible = true
      this.countName = list.name
      this.formulaText = list.formulaContentShow
    },
    handleOk() {
      this.submit()
    },
    reset() {
      this.id = null
      this.updateList =null
      this.formulaText=null
      this.countName=null
    },
    onClose () {
      this.visible = false
      this.reset()
    },
    testFormula(showSuccess = true) {
      // let { formulaText, testFormulaInfo } = state,
      let errorText = '', defaultError = '解析错误，请检查核对函数语法后重新输入： 1. 括号是否为英文输入状态下输入，是否使用除 + - * / = < > , " ( ) 以外的特殊符号； 2. 手动输入文本时，是否使用英文双引号标识 (如 "输入的文字"） 3. 是否存在并行函数 (如 函数(1) 函数(1) ) 4. 函数中是否存在多余的逗号， (如 函数(1,) )'
      const interpreter = new Interpreter(formulaFunctions)
      try {
        let formulaTextTrans = this.formulaText
        for(var i = 0;i < this.converdFields.length;i++){
          formulaTextTrans = formulaTextTrans.replaceAll(`{${this.converdFields[i].fieldName}}`, `{{${this.converdFields[i].fieldName}}}`)
        }
        const formulaTestData = convertNewFormulaToTest(formulaTextTrans, this.converdFields)
        console.log(formulaTestData,'1111111111')
        if (!isEmpty(formulaTestData.errorText)) throw new Error(formulaTestData.errorText)
        const testValue = interpreter.evaluate(formulaTestData.formulaText)
        console.log('Interpreter evaluate 计算结果', testValue)

        this.errorText = ''
        if (showSuccess) {
          this.isSuccess = false
          nextTick(() => (this.isSuccess = true))
        }
        return true
      } catch (e) {
        console.log(e)
        if (['SyntaxError'].includes(e.name)) this.errorText = defaultError
        else {
          this.errorText = e.message
          if (this.errorText.indexOf('is not defined') != -1) this.errorText = this.errorText.replace('is not defined', '未定义')
        }
        this.errorText = this.errorText
        this.isSuccess = false
        this.$message.error(this.errorText)
        return false
      }
    },
    submit() {
      // const { formulaText, fieldConfig, allColumns, needUpldateTable, thousandBitDivision } = state
      // const { aliasName, fieldId, actionType, viewId, scene } = props
      // const columnOptions = allColumns.find((v) => v.extra.field_id == fieldId)

      if (!this.formulaText) return this.$message.warning('请输入运算规则')
      if (!this.countName) return this.$message.warning('请输入名字')

      const convertedFormula = convertNewFormulaToPost(this.formulaText, this.converdFields)

      /** 公式合法性校验 */
      const isSuccess = this.testFormula(false)
      console.info(isSuccess)
      if (!isSuccess) return false
      let valFor = this.formulaText
      for(var i = 0;i < this.converdFields.length;i++){
        // let regex = new RegExp(`{{${this.converdFields[i].fieldName}}}`);
        valFor = valFor.replaceAll(`{${this.converdFields[i].fieldName}}`, `{${this.converdFields[i].fieldId}}`)
      }
      if(this.updateList){
        editGoodsFormula({
          formulaContent: valFor,
          formulaContentShow: this.formulaText,
          goodsId: this.id,
          name: this.countName,
          isUse: true,
          id: this.updateList.id
        }).then(response => {
          if(response.code != '20001'){
            this.$message.error(response.message)
            this.loading = false
          } else {
            this.$emit('ok')
            this.loading = false
            this.visible = false
            this.updateList = null
            this.reset()
          }
        })
      } else {
        goodGongshiAdd({
          formulaContent: valFor,
          formulaContentShow: this.formulaText,
          goodsId: this.id,
          name: this.countName,
          isUse: false
        }).then(response => {
          if(response.code != '20001'){
            this.$message.error(response.message)
            this.loading = false
          } else {
            this.$emit('ok')
            this.loading = false
            this.visible = false
            this.reset()
          }
        })
      }

    },
    insertText(text, insertType) {
      if (!insertType) {
        insertType = 'function'
      }
      this.$refs.formulaEditorRef.insertText(insertType !== 'function' ? `${text} ` : `${text}()`, insertType);
    },

    /** 清空报错信息 */
    clearErrorMessage() {
      // this.errorText = ''
      // this.isSuccess = false
    },

    /** 检测方法 */
    checkedFunction(options) {

    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .ant-tabs-nav .ant-tabs-tab {
  padding: 12px;
  margin: 0 !important;
}

/deep/ .ant-tabs-bar {
  border-bottom: solid 0px #eee;
  margin: 0;
}

/deep/ .ant-tabs-ink-bar {
  display: none !important;
}

.optionActive {
  background: skyblue;
}

.htmlDes {}
</style>
